import { CommercialProduct, cssVar, getSize } from 'metrix-common3';

// SecureMyOffer and BrokerBot, the products still sold, share the generic product icon.
const ProductClassIcon = ({ size }) => {
    const resolvedSize = size && getSize(size);
    return <CommercialProduct size={resolvedSize || 25} color={cssVar.colorPrimary} />;
};

export default ProductClassIcon;
